import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Space from '../components/Space';
import Message from '../components/Message';
import Loader from '../components/Loader';
import Paginate from '../components/Paginate';
//import SpaceCarousel from '../components/SpaceCarousel'
// import Meta from '../components/Meta'
import { listSpaces } from '../actions/spaceActions';
import {
  Jumbotron,
  Container,
  // Button,
  // Card,
  // CardDeck,
  Row,
  Col,
} from 'react-bootstrap';

const SpacesScreen = ({ match }) => {
  const keyword = match.params.keyword;

  const pageNumber = match.params.pageNumber || 1;

  const dispatch = useDispatch();

  const spaceList = useSelector(state => state.spaceList);
  const { loading, error, spaces, page, pages } = spaceList;

  useEffect(() => {
    dispatch(listSpaces(keyword, pageNumber));
  }, [dispatch, keyword, pageNumber]);

  return (
    <>
      <Jumbotron className='jumbotron3'>
        <Container>
          <h1>Book a space today</h1>
        </Container>
      </Jumbotron>
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <>
          <Row>
            {spaces.map(space => (
              <Col sm={12} md={6} lg={5} xl={4}>
                <Space space={space} />
              </Col>
            ))}
          </Row>
          <Paginate
            pages={pages}
            page={page}
            keyword={keyword ? keyword : ''}
          />
        </>
      )}
    </>
  );
};

export default SpacesScreen;
